import { render, staticRenderFns } from "./NationaliteAutocomplete.vue?vue&type=template&id=0f1ef5de&"
import script from "./NationaliteAutocomplete.vue?vue&type=script&lang=js&"
export * from "./NationaliteAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports